<template>
<div :class="['grocery-list-detail', { 'screen-lg': this.onTabletUp }]">
  <div class="grocery-list-staples" v-if="selectedItem.stapleItems.length">
    <h3>{{ $t('lblStaples') }}</h3>
    <p>{{ $t('lblStaplesInformation') }}</p>
    <div class="staple-item" v-for="staple in selectedItem.stapleItems">
      <div class="item-title">
        {{ staple.name || staple.ingredient.name }}
      </div>
      <BaseButton type="button" class="btn-clear secondary" @click="onDeleteItem(staple, true)">
        {{ $t('btnClear') }}
      </BaseButton>
      <BaseButton type="button" class="btn-clear" @click="addStapleToGroceryList(staple)">
        {{ $t('lblAdd') }}
      </BaseButton>
    </div>
  </div>

  <div class="additional-items-wrapper">
    <BaseGroceryListItem
      ref="swipeableItem"
      v-for="item in selectedItem.groceryItems"
      v-touch:swipe.left="swipeHandler(item)"
      :key="item.id"
      :item="item"
      :isDeletable="true"
      :isSelectable="true"
      @delete-item="onDeleteItem"
    />
    <div class="input-wrapper" v-for="(input, i) in this.inputs" :key="i">
      <BaseInputCustomItem
        style="padding-right: 5pt;"
        inputType="text"
        v-model="input.name"
        :showIcon="false"
        placeholder="Name"
        v-on:keyup.enter="onEnter(input)"
      />
      <BaseInputCustomItem inputType="text" v-model="input.count" placeholder="1 oz" v-on:keyup.enter="onEnter(input)" />
    </div>
    <BaseButton type="button" class="btn-secondary btn-block btn-add-list-item" @click="addItemInput">
      {{ $t('lblAddNewItem') }}
    </BaseButton>
  </div>
</div>
</template>

<script>
import store from '@state/store';
import { groceryListMethods, groceryListComputed } from '@state/helpers';

export default {
  name: 'grocery-list-detail',
  components: {},
  props: {
    isEmbed: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
    onTabletUp: {
      type: Boolean,
    },
  },
  data() {
    return {
      inputs: [],
    };
  },
  computed: {
    ...groceryListComputed,
    selectedItem() {
      return this.data;
    },
  },
  mounted() {},
  methods: {
    ...groceryListMethods,
    addItemInput() {
      const length = this.inputs.length;
      if (length && !this.inputs[length - 1].name) {
        return;
      } else {
        this.inputs.push({ name: '' });
      }
    },
    closeItem() {
      this.setSelectedItem(null);
    },
    async onDeleteItem(item, isStaple = null) {
      await this.deleteGroceryListItem(item.ingredientItemIds);
      isStaple ? this.setDeleteGroceryStapleItem(item) : this.setDeleteGroceryItem(item);
    },
    async onEnter(value) {
      const newItem = {
        count: value.count,
        name: value.name,
        categoryId: this.selectedItem.id,
      };

      const res = await this.addGroceryListItem(newItem);
      this.setNewGroceryItem({ categoryId: this.selectedItem.id, res });
      this.inputs = [];
    },
    addStapleToGroceryList(item) {
      this.addGroceryListStapleItem(item.ingredientItemIds);
      this.setDeleteGroceryStapleItem(item);
      this.setNewGroceryItem({ categoryId: this.selectedItem.id, item });
    },
    swipeHandler(item) {
      return (direction, event) => {
        // TODO: Handle swipe
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.grocery-list-detail {
  /* @extend %scrollable-drawer-content; */

  .grocery-list-staples {
    background-color: $color-grocery-list-staples-bg;
    padding: 2rem 1rem;

    p {
      color: $color-grocery-list-staples-text;
      font-size: 1.5rem;
      font-style: italic;
      line-height: 1.2;
      margin-bottom: 1.6rem;
    }
  }

  .staple-item {
    align-items: center;
    background-color: $color-grocery-list-item-bg;
    border: 1px solid $color-grocery-list-item-border;
    border-radius: $base-border-radius;
    display: flex;
    height: 7rem;
    margin-bottom: 0.5rem;
    padding: 1.25em 1em 1.25em 1em;

    &:hover,
    &:active {
      box-shadow: $color-grocery-list-item-shadow;
      cursor: pointer;
    }

    .item-icon {
      flex: 1;

      img {
        width: 60%;
      }
    }

    .item-title {
      color: $color-grocery-list-item-text;
      flex: 3;
      font-size: 1.7rem;
      font-weight: 600;
      line-height: 1;
    }

    .btn-clear {
      color: $color-action;
      font-weight: 400;
      text-transform: capitalize;

      &.secondary {
        color: $color-grocery-list-item-text-alt !important;
      }
    }

    button {
      margin-top: 0;
    }
  }

  .additional-items-wrapper {
    /* margin-bottom: 10rem; */
    margin-top: 1.5rem;

    /* overflow-y: scroll; */
    padding: 0 1.5rem 1rem;

    .input-wrapper {
      border: $size-input-border solid $color-input-border;
      border-radius: $size-input-border-radius;
      display: flex;
      margin-bottom: $size-grid-padding;
      position: relative;

      div:first-of-type {
        flex: 2;
      }
    }
  }

  &.screen-lg {
    position: relative;

    .additional-items-wrapper {
      /* height: 100vh; */
      margin-bottom: 0;

      /* padding-bottom: 20rem; */
    }
  }
}
</style>
